import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Button, FormData, ButtonGroup } from 'components/misc'
import { apiBlobs } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { logError } from 'redux/modules/app'

@apiBlobs()
@form({
  form: 'file-upload'
})
@connect(null, {
  logError
})
class FileUpload extends Component {
  static propTypes = {
    supportedTypes: PropTypes.array,
    actionText: PropTypes.string,
    actionIntlKey: PropTypes.string,
    uploadBlob: PropTypes.func.isRequired,
    logError: PropTypes.func.isRequired,
    onUploadComplete: PropTypes.func,
    autoupload: PropTypes.bool,
    resetFile: PropTypes.bool
  }

  static defaultProps = {
    autoupload: true,
    resetFile: false,
    actionText: 'Action',
    actionIntlKey: '',
    supportedTypes: [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ]
  }

  state = {
    file: null
  }

  componentWillReceiveProps = nextProps => {
    if (!this.props.resetFile && nextProps.resetFile) {
      this.handleRemoveFile()
    }
  }

  handleFileSelected = e => {
    const { autoupload } = this.props
    const file = e.target.files[0]

    this.setState({ file }, () => {
      autoupload && this.handleBlobUpdate(file)
    })
  }

  handleBlobUpdate = file => {
    this.props
      .uploadBlob({
        file
      })
      .then(({ body } = {}) => {
        if (this.props.onUploadComplete) {
          this.props.onUploadComplete({ url: body.url })
        }
      })
      .catch(err => this.props.logError(err))
  }

  handleRemoveFile = () => this.setState({ file: null })

  render() {
    const { supportedTypes, autoupload, actionIntlKey, actionText } = this.props
    const { file } = this.state

    return (
      <form>
        <div className="row">
          {!file && (
            <div className="col-xs-12">
              <FormData label="Select sheet from your computer" intlKey="label.select_sheet">
                <div className="base-margin--smaller">
                  <input
                    type="file"
                    onChange={this.handleFileSelected}
                    accept={supportedTypes}
                  />
                </div>
              </FormData>
            </div>
          )}
          {file && (
            <div>
              <div className="col-xs-12">
                <FormData label="Filename" intlKey="label.filename">
                  {get(file, 'name')}
                </FormData>
              </div>
              <div className="col-xs-12">
                <FormData label="Size" intlKey="label.size">
                  {get(file, 'size') && `${file.size / 1024} KB`}
                </FormData>
              </div>
              <div className="col-xs-12">
                <FormData label="Last modified" intlKey="label.last_modified">
                  {get(file, 'lastModified') && (
                    <FormattedDate value={file.lastModified} />
                  )}
                </FormData>
              </div>
            </div>
          )}
          <div className="col-xs-12">
            {!autoupload && (
              <ButtonGroup>
                <Button
                  disabled={!file}
                  type="button"
                  onClick={() => this.handleBlobUpdate(file)}
                >
                  {actionIntlKey ? (
                    <FormattedMessage
                      id={actionIntlKey}
                      defaultMessage={actionText}
                    />
                  ) : (
                    actionText
                  )}
                </Button>

                {file && (
                  <Button
                    disabled={!file}
                    type="button"
                    negative
                    intlKey="button.remove_file"
                    onClick={this.handleRemoveFile}
                  >
                    Remove file
                  </Button>
                )}
              </ButtonGroup>
            )}
          </div>
        </div>
      </form>
    )
  }
}

export default FileUpload
